/*
 * (c) Meta Platforms, Inc. and its affiliates.
 */

const MAX_ZOOM = 20;
export const IMG_ZOOM_START = 12;

const MIN_ZOOM_SCALE = 1;
const MAX_ZOOM_SCALE = 3;

// Calculate the scale for an image based on zoom
export const calcImgScale = (zoom: number) => {
	// calc gradient
	const gradient =
		(MAX_ZOOM_SCALE - MIN_ZOOM_SCALE) / (MAX_ZOOM - IMG_ZOOM_START);
	// calc constant
	const b = MAX_ZOOM_SCALE - MAX_ZOOM * gradient;
	// return zoom value based on Linear scale
	return zoom * gradient + b;
};
